import { loadScript } from '../tools/loadScript'
import { getEnvHost } from '../tools/getPlatform'

/*
支付方式有如下几种：
 1、WX_JSAPI, 微信JS
 2、WX_NATIVE, 微信原生
 3、ALI_PAY_WAP, 支付宝WAP
 4、ALI_PAY_DIRECT， 支付宝APP
 */
// import pingpp from 'pingpp-js'

/**
 *目前弃用（2019-03-04 zengshaop备注）
 * @param DATA PING++ JSON Obj
 * @param WeixinJSBridge // PING++ 提供的微信支付封装方法
 */
function onBridgeReady(wxData, backUrl, errUrl, toastTime = 1000) {
  return new Promise(resolve => {
    WeixinJSBridge.invoke('getBrandWCPayRequest', wxData, function(res) {
      resolve(res)
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // window.toast('支付成功')
        setTimeout(() => {
          window.location.href = backUrl
        }, toastTime)
      }
      if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        // window.toast('取消支付')
        setTimeout(() => {
          if (wxData && wxData.cancel_url) {
            window.location.href = wxData.cancel_url
          } else {
            window.location.reload()
          }
        }, toastTime)
      }
      if (res.err_msg == 'get_brand_wcpay_request:fail') {
        // window.toast(res.err_desc, 3000)
        setTimeout(() => {
          window.location.href = errUrl
        }, toastTime)
      }
    })
  })
}

//目前弃用（2019-03-04 zengshaop备注）
export function callWechatPay(wxData, backUrl, errUrl) {
  return new Promise(resolve => {
    const _onBridgeReady = () =>
      onBridgeReady(wxData, backUrl, errUrl).then(resolve)
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', _onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', _onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', _onBridgeReady)
      }
    } else {
      _onBridgeReady(wxData, backUrl, errUrl)
    }
  })
}

//ping++(支付宝支付方式)
export function pingppPay(charge) {
  // ping++ 现在接入了微信支付和支付宝支付，所以名字也改一下
  return new Promise((resolve, reject) => {
    loadScript('https://static.xinli001.com/frontend-lib/pingpp.js').then(
      () => {
        window.pingpp.createPayment(charge, function(err) {
          if (err) {
            console.error(err)
            reject(err)
          }
          resolve({
            msg: 'pingpp:success'
          })
          // pingpp.createPayment(charge, function(result, err) {
          //   if (err) {
          //     console.error(err)
          //   }
          // if (result == 'success') {
          //   // 支付成功埋点
          //   window.toast('支付成功')
          //   localStorage.setItem('canSend', 'canSend')
          //   window.location.href = backUrl
          // } else if (result == 'fail') {
          //   window.toast('支付失败')
          //   localStorage.setItem('canSend', 'canSend')
          //   window.location.href = errUrl
          // } else if (result == 'cancel') {
          //   window.toast('取消支付')
          //   localStorage.setItem('canSend', 'canSend')
          //   window.location.reload()
          // }
        })
      }
    )
  })
}

// /**
//  *
//  * @param DATA jsAPiJson
//  * @param callback
//  */
// export function wxJsPay(DATA) {
//   /*  这方法完成2个步骤
//      1、生成支付订单，返回支付参数
//      2、根据支付参数调用JSAPI请求支付，返回验证结果，用户输入密码
//      3、验证授权
//      */
//   let wxDone = function() {
//     return new Promise(resolve => {
//       wx.ready(function() {
//         wx.chooseWXPay({
//           timestamp: DATA.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
//           nonceStr: DATA.nonceStr, // 支付签名随机串，不长于 32 位
//           package: DATA.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
//           signType: DATA.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
//           paySign: DATA.paySign, // 支付签名
//           success: function(res) {
//             // 支付成功后的回调函数
//             alert("1");
//             console.log("支付res", res);
//             resolve(res);
//           },
//           fail: function(res) {
//             resolve(res);
//           },
//           cancel: function(res) {
//             resolve(res);
//           }
//         });
//       });
//     });
//   };
//   if (typeof wx === "undefined") {
//     loadScript("//res.wx.qq.com/open/js/jweixin-1.4.0.js").then(() => {
//       wxDone();
//     });
//   } else {
//     wxDone();
//   }
// }
/**
 *
 * @param DATA jsAPiJson
 * @param callback
 */
export function wxJsPay(DATA) {
  /*  这方法完成2个步骤
     1、生成支付订单，返回支付参数
     2、根据支付参数调用JSAPI请求支付，返回验证结果，用户输入密码
     3、验证授权
     */
  return new Promise(resolve => {
    wx.ready(function() {
      wx.chooseWXPay({
        timestamp: DATA.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: DATA.nonceStr, // 支付签名随机串，不长于 32 位
        package: DATA.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
        signType: DATA.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: DATA.paySign, // 支付签名
        success: function(res) {
          // 支付成功后的回调函数
          console.log(res)
          resolve(res)
        },
        fail: function(res) {
          resolve(res)
        },
        cancel: function(res) {
          resolve(res)
        }
      })
    })
  })
}

//支付宝直连
export function directAliPay(DATA) {
  console.log(DATA)
  return new Promise(() => {
    //直连的话拿返回的模拟表单提交直接提交
    const div = document.createElement('div')
    div.innerHTML = DATA
    document.body.appendChild(div)
    document.forms[0].submit()
  })
}

// node-zixun 支付宝直连
export function directAliPay2(DATA) {
  console.log(DATA)
  return new Promise(() => {
    //直连的话拿返回的模拟表单提交直接提交
    const div = document.createElement('div')
    div.innerHTML = DATA
    document.body.appendChild(div)
    const form = document.forms[document.forms.length - 1]

    if (form) {
      form.submit()
    }
  })
}

// 微信直连
export function directWechatPay(mwebUrl, success_url) {
  window.location.href =
    mwebUrl + `&redirect_url=` + encodeURIComponent(success_url)
}

//对外提供的方法，所有支付方式在这里进行判断
//allData表示传进来的数据，isWechat表示是否是微信
//微信不区分直连或者非直连，直接调用微信sdk
//支付宝会根据返回的支付方式进行直连或者ping++判断
export function allPay(allData, isWechat) {
  //   if (isWechat) {
  //     wxJsPay(allData.wx_data.body)
  //     // callWechatPay(allData.wx_data.body, allData.back_url, allData.error_url)
  //   } else {
  //     if (allData.ali_data) {
  //       if (allData.ali_data.type === 'direct') {
  //         directAliPay(allData.ali_data.body)
  //       } else {
  //         pingppPay(allData.ali_data.body, allData.back_url, allData.error_url)
  //       }
  //     } else {
  //       window.toast('接口请求错误，请重试', 3000)
  //     }
  //   }
  if (isWechat) {
    return wxJsPay(allData.body)
  } else {
    if (allData.type === 'pingpp') {
      return pingppPay(allData.body)
    }
    if (allData.type === 'direct') {
      return directAliPay(allData.body)
    }
  }
}

export function wechatAliPay(DATA, successUrl) {
  console.log(DATA)
  return new Promise(() => {
    const div = document.createElement('div')
    div.setAttribute('id', 'wechat-alipay-form-container')
    div.innerHTML = DATA
    document.body.appendChild(div)

    const action = div.querySelector('form').getAttribute('action')
    console.log(action)
    var queryParam = ''
    Array.prototype.slice
      .call(div.querySelectorAll('input[type=hidden]'))
      .forEach(function(ele) {
        console.log(`ele.name, ele.value`, ele.name, ele.value)
        var name = ele.name
        queryParam += '&' + name + '=' + encodeURIComponent(ele.value)
      })
    if (action.indexOf('?') === -1) {
      queryParam = queryParam.replace('&', '?')
    }
    console.log(`action + queryParam.replace('&', '?')`, action + queryParam)
    return loadScript(`//static.xinli001.com/frontend-lib/ap.js`).then(() => {
      window._AP.pay(action + queryParam, encodeURIComponent(successUrl))
    })
  })
}

export default {
  // callWechatPay,
  pingppPay,
  wxJsPay,
  allPay,
  wechatAliPay,
  directWechatPay
}



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/payUnit.js